/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Button, Cell, Grid, HFlow, Icon, Text, Tooltip } from 'bold-ui'
import { DateTime } from 'components/date'
import theme from 'config/theme'
import { Fragment, useState } from 'react'
import { EditableList, EditableRow } from 'view/atendimentos/detail/components/EditableList'

import { EvolucaoDenteSupranumerarioModel } from './DentesSupranumerariosField'
import { EditarDentesSupranumerariosModal } from './EditarDenteSupranumerarioModal'

export interface DentesSupranumerariosTableProps {
  cidadaoDataNascimento: LocalDate
  evolucoes: EvolucaoDenteSupranumerarioModel[]
  update(index: number, value: EvolucaoDenteSupranumerarioModel): void
  remove(index: number): void
}

export default function DentesSupranumerariosTable(props: DentesSupranumerariosTableProps) {
  const { cidadaoDataNascimento, evolucoes, update, remove } = props
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [editingRow, setEditingRow] = useState<EvolucaoDenteSupranumerarioModel>()

  const renderData = (row: EvolucaoDenteSupranumerarioModel) => <DateTime value={row.data} format='DD/MM/YYYY' />

  const renderLocal = (row: EvolucaoDenteSupranumerarioModel) => <div>{row.local}</div>

  const renderProcedimento = (row: EvolucaoDenteSupranumerarioModel) => (
    <div>
      {row.procedimentos.map((proced) => (
        <Text key={proced.id}>
          {proced.descricao} - {proced.codigo}
          <br />
        </Text>
      ))}
    </div>
  )

  const renderActions = (row: EvolucaoDenteSupranumerarioModel) => (
    <HFlow justifyContent='flex-end' hSpacing={0.5}>
      <Tooltip text='Editar'>
        <Button size='small' skin='ghost' onClick={() => onClickEditar(row)}>
          <Icon icon='penOutline' />
        </Button>
      </Tooltip>
      <Tooltip text='Excluir'>
        <Button size='small' skin='ghost' onClick={() => onClickExcluir(row)}>
          <Icon icon='trashOutline' />
        </Button>
      </Tooltip>
    </HFlow>
  )

  const onClickEditar = (row: EvolucaoDenteSupranumerarioModel) => {
    setEditingRow(row)
    setModalIsOpen(true)
  }

  const onClickExcluir = (row: EvolucaoDenteSupranumerarioModel) => remove(evolucoes.indexOf(row))

  const onSubmitEditar = (values: EvolucaoDenteSupranumerarioModel) => {
    editingRow && update(evolucoes.indexOf(editingRow), values)
    setEditingRow(undefined)
    setModalIsOpen(false)
  }

  const onCancelEditar = () => {
    setEditingRow(undefined)
    setModalIsOpen(false)
  }

  return (
    <Fragment>
      {evolucoes && evolucoes.length > 0 && (
        <Fragment>
          <EditableList
            css={css`
              max-width: 100%;
            `}
          >
            <div
              css={css`
                padding: 0.5rem 1rem;
                background-color: ${theme.pallete.primary.c100};
              `}
            >
              <Grid>
                <Cell size={2}>
                  <Text
                    fontWeight='bold'
                    style={css`
                      white-space: nowrap;
                    `}
                  >
                    Data do registro
                  </Text>
                </Cell>
                <Cell size={2}>
                  <Text fontWeight='bold'>Local</Text>
                </Cell>
                <Cell size={6}>
                  <Text fontWeight='bold'>Procedimentos</Text>
                </Cell>
                <Cell size={2}></Cell>
              </Grid>
            </div>

            {evolucoes.map((evolucao) => (
              <EditableRow editing={false}>
                <Grid
                  alignItems='center'
                  style={css`
                    margin: 0;
                  `}
                >
                  <Cell size={2}>{renderData(evolucao)}</Cell>

                  <Cell size={2}>{renderLocal(evolucao)}</Cell>

                  <Cell size={6}>{renderProcedimento(evolucao)}</Cell>

                  <Cell size={2} alignSelf='center'>
                    {renderActions(evolucao)}
                  </Cell>
                </Grid>
                {!!evolucao?.observacao?.trim().length && (
                  <HFlow
                    hSpacing={0.2}
                    style={css`
                      padding-bottom: 0.5rem;
                    `}
                  >
                    <Text fontWeight='bold'>Observações: </Text>
                    <Text
                      fontStyle='italic'
                      style={css`
                        word-break: break-all;
                      `}
                    >
                      {evolucao.observacao}
                    </Text>
                  </HFlow>
                )}
              </EditableRow>
            ))}
          </EditableList>
        </Fragment>
      )}

      <EditarDentesSupranumerariosModal
        isOpen={modalIsOpen}
        initialValues={editingRow}
        cidadaoDataNascimento={cidadaoDataNascimento}
        onSubmit={onSubmitEditar}
        onCancel={() => onCancelEditar()}
      />
    </Fragment>
  )
}
